import SVG from 'svg.js';

SVG.Element.prototype.draw.extend('line polyline polygon', {
  init() {
    this.set = new SVG.Set();
    const p = this.startPoint;
    const arr = [
      [p.x, p.y],
      [p.x, p.y],
    ];

    this.el.plot(arr);
  },
  calc(e) {
    const arr = this.el.array().valueOf();
    arr.pop();

    if (e) {
      const p = this.transformPoint(e.clientX, e.clientY);
      arr.push(this.snapToGrid([p.x, p.y]));
    }

    this.el.plot(arr);
  },

  point(e) {
    if (this.el.type.indexOf('poly') > -1) {
      const p = this.transformPoint(e.clientX, e.clientY);
      const arr = this.el.array().valueOf();
      arr.push(this.snapToGrid([p.x, p.y]));
      this.el.plot(arr);
      this.el.fire('drawpoint', { event: e, p: { x: p.x, y: p.y }, m: this.m });
      return;
    }

    this.stop(e);
  },

  clean() {
    if (this.set) {
      this.set.each(() => {
        this.remove();
      });

      this.set.clear();

      delete this.set;
    }
  },
});
